import { useMutation } from '@tanstack/react-query';
import { getExerciseResolution } from '../queries/module';
import { useExerciseResolutionStore } from '../stores/exerciseResolution';

export function useExerciseResolution() {
  const {setExerciseResolution} = useExerciseResolutionStore()

  const { mutate, isPending, isError } = useMutation({
    mutationKey: ['exercise-resolution'],
    mutationFn: (slug: string) => getExerciseResolution(slug),
    retry: false,
    onSuccess: (result) => {
      setExerciseResolution(result)
    }
  });

  return { mutate, isLoading: isPending, isError };
}
